var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5648 0.420945L5.8731 8.1857L2.498 4.46892C2.13321 4.05299 1.59302 3.88618 1.08504 4.03261C0.57706 4.17903 0.180351 4.6159 0.0473878 5.17531C-0.0855756 5.73471 0.0658986 6.32959 0.443591 6.73131L4.80231 11.5313C5.3524 12.1372 6.23825 12.1583 6.81168 11.5793L15.5291 2.77933C15.9117 2.39292 16.078 1.8111 15.9654 1.25305C15.8528 0.694995 15.4784 0.245489 14.9832 0.0738535C14.488 -0.0977821 13.9473 0.0345283 13.5648 0.420945Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick.c89439f6166fd7518616a807b35341e0.svg";